import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useProposalStatuses, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const ProposalStatusPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="proposal_status"
      hook={useProposalStatuses}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addProposalStatus"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="proposal_status"
    />
  );
};

export default ProposalStatusPage;
